import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {StoreSelectorsService} from "../../../../services";
import {IButtonBar} from "../../../../components/add-remove-bar/button-bar.component";
import {ITableListColumn} from "../../../../components/table-list-input/table-list-input.component";
import {DialogGetAssetComponent, IDialogGetAsset} from "../../../../components/dialog-get-asset/dialog-get-asset.component";
import {SceneMimeTypes} from "../mime-constants";
import {IAppSettingsWrap, IDefaultAd} from "../../../../interfaces";
import * as _ from 'lodash';

@Component({
    selector: 'app-scene-block-adnet',
    templateUrl: './block-adnet.component.html',
    styleUrls: ['./block-adnet.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlockAdnetComponent extends BlockBaseComponent {

    buttons: IButtonBar[] = [];
    tableColumns: Array<ITableListColumn> = [];
    coreAppData: IAppSettingsWrap;

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog, public cd: ChangeDetectorRef) {
        super(storeSelector, dialog);
        this.initButtons();
        this.cod(
            this.storeSelector.getCoreData()
                .subscribe((i_coreData: IAppSettingsWrap) => this.coreAppData = i_coreData)
        );
    }

    override submit(formValues) {
        if (formValues?.Default?.currentAction == 'added') {
            this.openAssociateDialog();
            // this.storeSelector.dispatch(actionSceneItemLocation({indexes: []}));
            return;
        }
        super.submit(formValues);
    }

    openAssociateDialog() {
        const data: IDialogGetAsset = {mode: "RESOURCE:ALL", mimeType: SceneMimeTypes.Player};
        const dialogRefVal = this.dialog.open(DialogGetAssetComponent, {
            width: '70%',
            panelClass: 'custom-dlg-container',
            data
        });
        this.cod(
            dialogRefVal.afterClosed()
                .subscribe((dialogGetAsset: IDialogGetAsset) => {
                    if (!dialogGetAsset?.selectedType) return;
                    const url = `${this.coreAppData[1].protocol}${this.coreAppData[0].businessDomain}/Resources/business${this.coreAppData[0].businessId}/resources/${dialogGetAsset.sourceData.resource_id}.${dialogGetAsset.sourceData.resource_type}`;
                    this.addTableItem(dialogGetAsset, url, dialogGetAsset.sourceData.resource_name);
                })
        );
    }

    addTableItem(dialogGetAsset: IDialogGetAsset, url: string, name: string) {
        const ads: Array<IDefaultAd> = _.cloneDeep(this.sceneItem.Data[0].AdNet[0].DefaultList[0].Default);
        const ad: IDefaultAd = {
            $: {
                name,
                duration: '5',
                url
            }
        };
        ads.push(ad);
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'Default',
                value: ads,
                storePath: 'Data[0].AdNet[0].DefaultList[0]'
            }]
        });
        super.initApplyStoreToDynamic(true);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        this.cd.markForCheck();
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "select",
                label: this.translocoService.translate('general.playShare', {}, this.translocoService.getActiveLang()),
                name: "channel",
                value: "0",
                ignoreMissingValue: true,
                options: [
                    {
                        optionsLabel: 'CH 0',
                        optionValue: '0',
                        optionType: '0'
                    },
                    {
                        optionsLabel: 'CH 1',
                        optionValue: '1',
                        optionType: '1'
                    },
                    {
                        optionsLabel: 'CH 2',
                        optionValue: '2',
                        optionType: '2'
                    },
                    {
                        optionsLabel: 'CH 3',
                        optionValue: '3',
                        optionType: '3'
                    },
                ],
                storePath: 'Data[0].AdNet[0].$.channel'
            },
            {
                type: "input",
                value: '1',
                label: this.translocoService.translate('general.minutes', {}, this.translocoService.getActiveLang()),
                inputType: "number",
                min: 1,
                step: 1,
                name: "defaultMaxInterval",
                storePath: 'Data[0].AdNet[0].$.defaultMaxInterval'
            },
            {
                type: "input",
                label: '',
                inputType: 'tablelist',
                tableColumns: this.tableColumns,
                confirmRemove: true,
                buttons: this.buttons,
                inputEditFormat: {url: 'text', duration: 'number', name: 'text'},
                inputEditRenamePath: [{path: '$.url', key: 'url'}, {path: '$.name', key: 'name'}, {path: '$.duration', key: 'duration'}],
                allowFilter: true,
                name: "Default",
                cloneVals: true,
                ignoreMissingValue: true,
                expandableEditor: true,
                storePath: 'Data[0].AdNet[0].DefaultList[0].Default'
            }
        ];
    }

    initButtons() {
        this.tableColumns = [
            {
                inputType: 'edit',
                name: 'name',
                maxStringSize: '9'
            },
            {
                inputType: 'edit',
                name: 'url',
                maxStringSize: '12'
            }, {
                inputType: 'edit',
                name: 'duration',
                maxStringSize: '12'
            }
            /** example of dropdown select **/
            // , {
            //     inputType: 'select',
            //     name: 'type',
            //     maxStringSize: '16',
            //     selectValues: ['1', '2', '3'],
            //     selectValue: '2'
            // }
        ];

        this.buttons = [
            {
                callBack: v => (v),
                icon: 'add',
                name: 'add',
                disableByList: false,
                disabled: false
            },
            {
                callBack: v => (v),
                icon: 'remove',
                name: 'remove',
                disableByList: true,
                disabled: false
            }
        ];
    }

}

